import { useContext } from 'react';

import type { TeamsClientOptions } from './context';
import { TeamsClientContext } from './context';

type UseTeamsClientContext = () => TeamsClientOptions;
export const useTeamsClientContext: UseTeamsClientContext = () => useContext(TeamsClientContext);
